import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AuthChrome } from '../components/AuthChrome';

/**
 * `/auth` — the sign-in / sign-up / password-reset shell.
 *
 * No redirect for an already-signed-in visitor: the original app renders a "you are signed in"
 * message on `/auth/login` instead of bouncing, which matters because this is the URL an expired
 * session lands on. Redirecting straight back into the dashboard would produce a loop whenever the
 * token is dead but still present.
 */
export const Route = createFileRoute('/auth')({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <AuthChrome>
      <Outlet />
    </AuthChrome>
  );
}
